import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";

export const PageShell = ({ children }) => {
  return (
    <div className="min-h-screen bg-[#F4F1EB] text-[#1C2C22]">
      <Header />
      <main className="pt-20">{children}</main>
      <Footer />
    </div>
  );
};

export default PageShell;
